import React from 'react'
import t from 'prop-types'
import LabelList from '../../Labels/LabelList'

const HeaderSuccessStory = ({ heading, subheading, labels, tags }) => {
  return (
    <div className="container mb-16">
      <div className="lg:max-w-screen-lg lg:pr-10">
        {labels && (
          <div className="mb-8">
            <LabelList labels={labels}></LabelList>
          </div>
        )}
        <h1 className="font-serif text-4xl lg:text-5xl font-bold leading-tight">
          {heading}
        </h1>
        {subheading && (
          <h2 className="mt-6 font-serif text-3xl lg:text-4xl font-light leading-tight">
            {subheading}
          </h2>
        )}
        {tags && (
          <div className="mt-8">
            <LabelList isSecondary labels={tags}></LabelList>
          </div>
        )}
      </div>
    </div>
  )
}

HeaderSuccessStory.propTypes = {
  heading: t.string,
  subheading: t.string,
  labels: t.object,
  tags: t.object,
}

HeaderSuccessStory.defaultProps = {}

export default HeaderSuccessStory
